import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { sendAnalyticsOnBlockVisibility } from "../blocks/analytics";
import { useInView } from "./useInView";
export var useViewportAnalytics = function useViewportAnalytics(ref, analyticBlockTitle, pageType) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    isOnce = _useState2[0],
    setIsOnce = _useState2[1];
  var inView = useInView(ref, {
    threshold: 0.9
  });
  useEffect(function () {
    if (!isOnce && inView && analyticBlockTitle) {
      sendAnalyticsOnBlockVisibility(pageType, analyticBlockTitle);
      setIsOnce(true);
    }
  }, [inView, analyticBlockTitle]);
};